<template>
  <div data-testid="view-project__view">
    <BotFlow v-if="botid" :botid="botid" :config="{review: true}"></BotFlow>
  </div>
</template>

<script>
import BotFlow from '../../../views/conserve/BotFlow.vue';
export default {
  name: 'bots_view',
  // props: ['props'],
  data: function () {
    return {
      botid: "",
      project: "",
    }
  },
  components: {
    BotFlow
  },
  created() {
    this.refreshData();
  },
  activated() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      this.botid = this.$route.params.botID;
    },
  },
  watch: {
  }
}
</script>
